import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "var(--sds--ursa-icons--inner-shape-color, transparent)",
  fillRule: "evenodd",
  d: "M12 14.45a.7.7 0 0 1-.7-.7V9.741a.7.7 0 1 1 1.4 0v4.01a.7.7 0 0 1-.7.7",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "var(--sds--ursa-icons--inner-shape-color, transparent)",
  d: "M11.15 16.2a.8.8 0 1 1 1.6 0 .8.8 0 0 1-1.6 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M14.63 5.419c-1.169-2.025-4.091-2.025-5.26 0l-5.98 10.36c-1.11 1.92.277 4.321 2.495 4.321h12.23c2.219 0 3.605-2.4 2.496-4.321zM11.3 13.75a.7.7 0 1 0 1.4 0V9.741a.7.7 0 1 0-1.4 0zm.65 1.65a.8.8 0 1 0 0 1.6.8.8 0 0 0 0-1.6",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
export default ForwardRef;
//# sourceMappingURL=WarningFilledIcon24.js.map